import { useContext } from 'react';
import {
  Skeleton,
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { Section } from '../../../components/ui/Section';
import WasteChecksheetTable from './WasteChecksheetTable';
import WasteChecksheetSearchFilterBar from './WasteChecksheetSearchFilterBar';

import { Pill } from '../../../components/shared/Pill';
import { WasteChecksheetDetailContext, WasteChecksheetDetailValues } from '../contexts/WasteChecksheetDetailContext';


const WasteChecksheetMainBox = () => {
  const { isLoading,
    itemsData,
    itemsByCategory,
    isMobile,
    isWasteLogUnitSupportEnabled,
    filteredItemsByCategory,
  } = useContext(WasteChecksheetDetailContext) as WasteChecksheetDetailValues;
  const theme = useTheme();

  if (isLoading || itemsByCategory.length == 0) return <>
    {isMobile && <Skeleton variant="rectangular"
      height={40}
      sx={{ borderRadius: '12px', mb: '12px' }} />}
    <Skeleton variant="rectangular"
      height={1000}
      sx={{ borderRadius: '12px' }} />
  </>;

  return (
    <Section>
      <Box sx={{ p: 5 }}>
        <Typography variant='textMD'
          fontWeight={600}
          sx={{ display: 'flex', alignItems: 'center' }}>
          {'Waste Log'}
          <Pill text={`${itemsData.itemCount} Items`}></Pill>
          <Pill text={`${itemsByCategory.length} Categories`}
            pallet={theme.palette.warning}></Pill>
        </Typography>
      </Box>
      {isWasteLogUnitSupportEnabled && <WasteChecksheetSearchFilterBar />}
      {filteredItemsByCategory.map(({ category, originalCategoryIndex }) => (
        <WasteChecksheetTable key={category.name}
          category={category}
          originalCategoryIndex={originalCategoryIndex} />))}
    </Section >
  );
};

export default WasteChecksheetMainBox;